import type { ScheduleMenuAnalyticProps, ScheduleMenuOwnProps } from 'components/shared/ScheduledRun/ScheduleMenu';
import { connectScheduleMenu } from 'components/shared/ScheduledRun/ScheduleMenu';
import type { IBlotterQuoteItemStatus } from 'models/IBlotterItem';
import { isScheduledRunOnBlotterEnabled } from 'state/scheduledRuns/utils';

interface OwnProps extends ScheduleMenuOwnProps, ScheduleMenuAnalyticProps {
  externalQuoteId: string;
  productType?: string;
  productSubType?: string;
  quoteStatus?: IBlotterQuoteItemStatus;
}
export const ConnectedScheduleMenu = connectScheduleMenu<OwnProps>(
  (state, { externalQuoteId, productType, productSubType, quoteStatus }) => ({
    quotes: [{ quoteId: externalQuoteId, productSubType, productType }],
    isVisible: isScheduledRunOnBlotterEnabled(state, quoteStatus),
  }),
);
